import React, { useState, useEffect } from "react";
import axios from 'axios';

import LoginError from "./LoginError";
import { Container, Row, Col, Button, Form, FloatingLabel } from 'react-bootstrap';
import { useGoogleLogin } from '@react-oauth/google';

import { saveCredentials } from "./authSlice";
import { useLoginMutation, useCreateUserMutation } from "../../app/api";

//import { googleLogout, useGoogleLogin } from '@react-oauth/google';

export default function Login() {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [errorStatusCode, setErrorStatusCode] = useState(undefined);
    const [isError, setIsError] = useState(false);

    const [showSignup, setShowSignup] = useState(false);

    const [login, { isLoading, logIsError }] = useLoginMutation();

    const [createUser ] = useCreateUserMutation();

    const canLogin = !isLoading && username.length > 0 && password.length > 0;
    const canSignUp = !isLoading && ( (!showSignup ) || ( !isLoading && showSignup && username.length > 0 && password.length > 0 && confirmPassword.length > 0 ) ) ;

    useEffect(() => {
        if (logIsError) {
            setIsError(true);
        } 
    }, logIsError)

    async function onLogin() {
        setErrorStatusCode(undefined);
        setIsError(false);
        try {
            // Submit the login attempt
            const result = await login({ username, password }).unwrap();
            // Reached here when the request is successful. The access token and
            // username have been updated in the local state by authSlice.
            // Save the access token and username to local storage
            console.log('the role is: ', result.permissions);
            if (result.permissions && result.permissions == 'pending') {
                setErrorStatusCode(222);
                // dont set username when pending
                saveCredentials(result.access_token, '', result.permissions);
            } else {
                saveCredentials(result.access_token, username, result.permissions);
            }
        } catch (err) {
            // Set the error status code, if available, for the LoginError component
            setErrorStatusCode(err.status);
        }
    }

    const submitSignUp = async () => {
        if (password != confirmPassword) {
            setErrorStatusCode(123);
        }
        else {
            const {error: createError} = await createUser({username: username, password: password});
            if (createError) {
                if (createError.status == 400) {
                    setErrorStatusCode(111);
                } else {
                    setErrorStatusCode(createError.status);
                }
            }
            else {
                setShowSignup(false);
                setErrorStatusCode(222);
            }
        }
    }

    const runShowSignUp = () => { 
        setShowSignup(true); 
        setErrorStatusCode(undefined); 
        setIsError(false);
    }
  

    // GOOGLE LOG IN
    const [ user, setUser ] = useState(null);
    const [ profile, setProfile ] = useState([]);

    const loginWithGoogle = useGoogleLogin({
        onSuccess: (codeResponse) => setUser(codeResponse),
        onError: (error) => console.log('Login Failed:', error)
    });

    useEffect(() => {
        if (user) {
            axios.get(`https://www.googleapis.com/oauth2/v1/userinfo?access_token=${user.access_token}`,{
                headers: {
                    Authorization: `Bearer ${user.access_token}`,
                    Accept: 'application/json'
                }
            }).then((res) => {
                console.log('setting profile data from google user info call');
                setProfile(res.data);
            }).catch((err) => console.log(err));
        }
    },[user]);

    useEffect( () => {
        if(profile.hd){
            if (profile.hd != 'ffn.com'){
                setIsError(true);
                setErrorStatusCode(223);
            } else {
                setUsername(profile.email);
                setPassword(profile.id);
            }
        }
    }, [profile])

    useEffect( () => {
        if (username && password) {
            onLogin();
        }
    }, [username, password])

    return (
    <Container id='auth'>

        <Row>
            <Col className='text-center w-100 mt-5 mb-5'>
                <h1 className='fs-1 fw-bold mt-2'>Emails and Newsletters</h1>
                {isLoading && 
                <div className="spinner-border" role="status"><span className="sr-only"/></div>
                }
                <h3 className='grey fs-5 mt-1'>{!isLoading && (showSignup ? "SIGN UP" : "LOG IN")}</h3>
            </Col>
        </Row>

        {/* <Row className='justify-content-sm-center flex-fill gy-5 hidden'>
            <Col className='text-center w-100'>
                <FloatingLabel controlId='floatingInput' label='Email address' className='mb-3'>
                    <Form.Control
                        type="text"
                        autoComplete="username"
                        placeholder="name@example.com"
                        value={username}
                        onChange={ (e)=>setUsername(e.target.value) }
                    />
                </FloatingLabel>
                <div className='hidden'>
                    <FloatingLabel controlId='floatingPassword' label='Password' className='mb-3'>
                        <Form.Control
                            type="password"
                            autoComplete="current-password"
                            placeholder="Enter password"
                            value={password}
                            onChange={ (e)=>setPassword(e.target.value) }
                        />
                    </FloatingLabel>
                </div>
                {showSignup && 
                    <FloatingLabel controlId='floatingConfirmPassword' label='Confirm Password' className='mb-3'>
                        <Form.Control
                            type="password"
                            placeholder="Confirm password"
                            onChange={(e) => setConfirmPassword(e.target.value)}
                        />
                    </FloatingLabel>
                }
            </Col>
        </Row> */}

        {(isError || errorStatusCode) && (<LoginError className='red' errorStatusCode={errorStatusCode} />)}

        {!showSignup && 
        <>
            <Row className='justify-content-sm-center flex-fill gy-5'>
                <Col className='text-center w-100'>
                    <div className="d-grid gap-2">
                        <Button onClick={ ()=> {setIsError(false); loginWithGoogle(); } } 
                                // disabled={ !canLogin } 
                                className='mt-2'
                                size="lg"
                                as="input" 
                                type="submit" 
                                value="Log In With Google" />
                    </div>
                </Col>
            </Row>
            <Row className='mt-4 hidden'>
                <Col><hr/></Col>
                <Col xs={1} className="align-items-center">
                    <p className="text-center fw-bold mb-0 text-muted">OR</p>
                </Col>
                <Col><hr/></Col>
            </Row>
        </>
        }

        {/* <Row className='hidden'>
            <div className="d-grid gap-2 mt-2">
                <Button onClick={()=> {showSignup ? submitSignUp() : runShowSignUp()}} className='mt-2' as="input" type="submit" value="Sign Up" size="lg" disabled={!canSignUp}/>
            </div>
        </Row> */}

        {showSignup && 
        <>
            <Row className='mt-4'>
                <Col><hr/></Col>
                <Col xs={1} className=" align-items-center ">
                    <p className="text-center fw-bold mb-0 text-muted">OR</p>
                </Col>
                <Col><hr/></Col>
            </Row>
            <Row >
                <div className="d-grid gap-2 mt-2">
                    <Button onClick={()=> {setIsError(false); onLogin(); }} className='mt-2 ' as="input" type="submit" value="Log In With Google" size="lg"/>
                </div>
            </Row>
        </>
        }

    </Container>
    );
}